// const source = 'podsDataTable'

function uploadMultipdrsFile () {

  

    this.$eventBus.emit('show-dialog-page', {
      page: 'pdrs-multipdrs-file',
      title: 'Multipdrs File',
      data: [],
      maximize: false,

    })
  
}

export default {
  'bindTo': 'this',
  'method': uploadMultipdrsFile,
}
